export default __webpack_public_path__ + "static/media/Shemite Exile Tunic.4aede284.jpg";